import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=cb33818e&scoped=true&lang=pug"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"
import style0 from "./StarRating.vue?vue&type=style&index=0&id=cb33818e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb33818e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb33818e')) {
      api.createRecord('cb33818e', component.options)
    } else {
      api.reload('cb33818e', component.options)
    }
    module.hot.accept("./StarRating.vue?vue&type=template&id=cb33818e&scoped=true&lang=pug", function () {
      api.rerender('cb33818e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/StarRating.vue"
export default component.exports